module.exports = __webpack_public_path__ + "static/menu-items-b1c61308c418b39a28c7f522b6e696e2.gif";